/* Trendya theme — vanilla JS, no dependencies. */
(() => {
  'use strict';

  const T = window.Trendya || {};
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motion = T.animations !== false && !reduceMotion;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------------------------------------------------------------------
     Overlays: scrim + focus handling shared by drawers
     --------------------------------------------------------------------- */
  const scrim = $('[data-scrim]');
  let openLayer = null;
  let lastFocus = null;

  function openOverlay(el, focusTarget) {
    if (!el) return;
    if (openLayer && openLayer !== el) closeOverlay(openLayer, false);
    lastFocus = document.activeElement;
    openLayer = el;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (scrim) {
      scrim.hidden = false;
      requestAnimationFrame(() => scrim.classList.add('is-on'));
    }
    document.documentElement.style.overflow = 'hidden';
    const target = focusTarget || el.querySelector('input, button, a');
    if (target) setTimeout(() => target.focus({ preventScroll: true }), 80);
  }

  function closeOverlay(el = openLayer, restore = true) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (scrim) {
      scrim.classList.remove('is-on');
      setTimeout(() => { if (!openLayer) scrim.hidden = true; }, 400);
    }
    document.documentElement.style.overflow = '';
    openLayer = null;
    $$('[aria-expanded="true"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (restore && lastFocus) lastFocus.focus({ preventScroll: true });
  }

  scrim && scrim.addEventListener('click', () => closeOverlay());
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && openLayer) closeOverlay();
  });

  /* ---------------------------------------------------------------------
     Header: hide on scroll down, nav ink follower, mobile menu, search
     --------------------------------------------------------------------- */
  const headerSection = $('.section-header');
  let lastY = window.scrollY;
  let ticking = false;
  function onScrollHeader() {
    const y = window.scrollY;
    if (headerSection) {
      headerSection.classList.toggle('is-scrolled', y > 10);
      const goingDown = y > lastY && y > 240;
      headerSection.classList.toggle('is-hidden', goingDown && !openLayer);
    }
    lastY = y;
    ticking = false;
  }
  window.addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(onScrollHeader); ticking = true; }
  }, { passive: true });

  const nav = $('.nav');
  const ink = $('[data-nav-ink]');
  if (nav && ink) {
    const moveInk = (link) => {
      const navBox = nav.getBoundingClientRect();
      const box = link.getBoundingClientRect();
      ink.style.width = `${box.width}px`;
      ink.style.transform = `translateX(${box.left - navBox.left}px)`;
      ink.style.opacity = '1';
    };
    $$('.nav__link', nav).forEach((link) => {
      link.addEventListener('mouseenter', () => moveInk(link));
      link.addEventListener('focus', () => moveInk(link));
    });
    nav.addEventListener('mouseleave', () => { ink.style.opacity = '0'; });
  }

  const menuDrawer = $('[data-menu-drawer]');
  $$('[data-menu-open]').forEach((btn) => btn.addEventListener('click', () => {
    btn.setAttribute('aria-expanded', 'true');
    openOverlay(menuDrawer, $('[data-menu-close]', menuDrawer));
  }));
  $$('[data-menu-close]').forEach((btn) => btn.addEventListener('click', () => closeOverlay()));

  const searchOverlay = $('[data-search-overlay]');
  $$('[data-search-open]').forEach((btn) => btn.addEventListener('click', () => openOverlay(searchOverlay, $('[data-predictive-input]', searchOverlay))));
  $$('[data-search-close]').forEach((btn) => btn.addEventListener('click', () => closeOverlay()));

  /* Predictive search */
  const pInput = $('[data-predictive-input]');
  const pResults = $('[data-predictive-results]');
  if (pInput && pResults) {
    let timer;
    let controller;
    pInput.addEventListener('input', () => {
      clearTimeout(timer);
      const q = pInput.value.trim();
      if (q.length < 2) { pResults.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        controller && controller.abort();
        controller = new AbortController();
        try {
          const url = `${T.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=4`;
          const res = await fetch(url, { signal: controller.signal });
          const data = await res.json();
          const products = (data.resources && data.resources.results.products) || [];
          if (!products.length) {
            pResults.innerHTML = '<p class="search-page__count">No hay resultados para esta búsqueda.</p>';
            return;
          }
          const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
          pResults.innerHTML = `<div class="predictive">${products.map((p) => `
            <a class="predictive__item" href="${esc(p.url)}">
              ${p.image ? `<img src="${esc(p.image)}&width=400" alt="" width="400" height="500">` : ''}
              <span>${esc(p.title.replace(/^Trendya Madrid\s+/, ''))}</span>
              <span class="price">${formatMoney(Math.round(parseFloat(p.price) * 100))}</span>
            </a>`).join('')}
            <a class="predictive__all link-underline" href="${T.routes.search}?q=${encodeURIComponent(q)}&type=product">Ver todos los resultados</a>
          </div>`;
        } catch (err) {
          if (err.name !== 'AbortError') pResults.innerHTML = '';
        }
      }, 220);
    });
  }

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const withDots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const fmt = T.moneyFormat || '{{amount_with_comma_separator}} €';
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, `${withDots},${dec}`)
      .replace(/\{\{\s*amount\s*\}\}/, `${int.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${dec}`)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withDots)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, int);
  }

  /* ---------------------------------------------------------------------
     Announcement rotator
     --------------------------------------------------------------------- */
  const announce = $('[data-announce]');
  if (announce) {
    const msgs = $$('.announce__msg', announce);
    let idx = 0;
    let auto;
    const show = (next) => {
      if (msgs.length < 2) return;
      const cur = msgs[idx];
      idx = (next + msgs.length) % msgs.length;
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      setTimeout(() => cur.classList.remove('is-leaving'), 650);
      msgs[idx].classList.add('is-active');
    };
    const start = () => { if (msgs.length > 1) auto = setInterval(() => show(idx + 1), 5000); };
    $('[data-announce-next]', announce).addEventListener('click', () => { clearInterval(auto); show(idx + 1); start(); });
    $('[data-announce-prev]', announce).addEventListener('click', () => { clearInterval(auto); show(idx - 1); start(); });
    if (msgs.length < 2) $$('.announce__nav', announce).forEach((b) => { b.hidden = true; });
    start();
  }

  /* ---------------------------------------------------------------------
     Cart: AJAX add / change, drawer re-render via Section Rendering API
     --------------------------------------------------------------------- */
  const cartDrawerSection = () => $('#shopify-section-cart-drawer');

  async function refreshCart(open = false) {
    const res = await fetch(`${T.routes.root}?sections=cart-drawer`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = $('[data-cart-drawer-inner]', html);
    const drawer = $('[data-cart-drawer]');
    if (fresh && drawer) $('[data-cart-drawer-inner]', drawer).replaceWith(fresh);
    const cart = await fetch(`${T.routes.cart}.js`).then((r) => r.json());
    updateCount(cart.item_count);
    bindCartDrawer();
    if (open) openOverlay(drawer, $('[data-drawer-close]', drawer));
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
    $$('[data-cart-open]').forEach((a) => a.setAttribute('aria-label', `Cesta, ${count} artículos`));
  }

  async function changeLine(line, quantity) {
    const res = await fetch(`${T.routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (!res.ok) throw new Error('change failed');
    await refreshCart(false);
  }

  function bindCartDrawer() {
    const drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    $$('[data-drawer-close]', drawer).forEach((b) => { b.onclick = () => closeOverlay(); });
    $$('.line', drawer).forEach((row) => {
      const line = parseInt(row.dataset.line, 10);
      const input = $('[data-qty-input]', row);
      const set = (q) => { row.classList.add('is-updating'); changeLine(line, Math.max(0, q)).catch(() => row.classList.remove('is-updating')); };
      $$('[data-qty-change]', row).forEach((b) => { b.onclick = () => set(parseInt(input.value, 10) + parseInt(b.dataset.qtyChange, 10)); });
      input.onchange = () => set(parseInt(input.value, 10) || 0);
      const rm = $('[data-line-remove]', row);
      if (rm) rm.onclick = () => set(0);
    });
  }
  bindCartDrawer();

  $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
    if (document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    openOverlay($('[data-cart-drawer]'), $('[data-drawer-close]'));
  }));

  /* ---------------------------------------------------------------------
     Product page: variant picker, gallery, add to cart, zoom
     --------------------------------------------------------------------- */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    const data = JSON.parse(jsonEl.textContent);
    const form = $('[data-product-form]', root);
    const idInput = $('[data-variant-id]', root);
    const priceEl = $('[data-product-price]', root);
    const atc = $('[data-atc]', root);
    const atcLabel = $('[data-atc-label]', root);
    const stock = $('[data-stock]', root);
    const skuEl = $('[data-sku]', root);
    const errEl = $('[data-form-error]', root);
    const fieldsets = $$('.opt', root);

    const selected = () => fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });

    function placeGlider(fs) {
      const glider = $('.opt__glider', fs);
      const checked = $('input:checked', fs);
      if (!glider || !checked) return;
      const pill = checked.nextElementSibling;
      glider.style.width = `${pill.offsetWidth}px`;
      glider.style.height = `${pill.offsetHeight}px`;
      glider.style.transform = `translate(${pill.offsetLeft}px, ${pill.offsetTop}px)`;
    }

    function markAvailability() {
      const sel = selected();
      fieldsets.forEach((fs, i) => {
        $$('input', fs).forEach((input) => {
          const test = sel.slice();
          test[i] = input.value;
          const match = data.variants.find((v) => v.options.every((o, k) => o === test[k]));
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function update() {
      const sel = selected();
      const variant = data.variants.find((v) => v.options.every((o, i) => o === sel[i]));
      fieldsets.forEach((fs) => {
        const out = $('[data-option-value]', fs);
        const c = $('input:checked', fs);
        if (out && c) out.textContent = c.value;
        placeGlider(fs);
      });
      markAvailability();
      if (!variant) {
        atc.disabled = true;
        atcLabel.textContent = T.strings.unavailable || 'No disponible';
        return;
      }
      idInput.value = variant.id;
      priceEl.textContent = variant.price;
      if (skuEl) skuEl.textContent = variant.sku || '';
      atc.disabled = !variant.available;
      atcLabel.textContent = variant.available ? 'Añadir a la cesta' : 'Agotado';
      stock.innerHTML = variant.available ? '<span class="dot dot--ok"></span> En stock' : '<span class="dot"></span> Agotado en esta talla';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (variant.media) goToMedia(variant.media);
    }

    fieldsets.forEach((fs) => {
      $$('input', fs).forEach((input) => input.addEventListener('change', update));
    });
    requestAnimationFrame(() => { fieldsets.forEach(placeGlider); markAvailability(); });
    window.addEventListener('resize', () => fieldsets.forEach(placeGlider));

    $$('[data-qty-step]', root).forEach((b) => b.addEventListener('click', () => {
      const input = $('input[name="quantity"]', form);
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
    }));

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (atc.disabled) return;
      errEl.hidden = true;
      atc.classList.add('is-loading');
      atcLabel.textContent = 'Añadiendo…';
      try {
        const res = await fetch(`${T.routes.cartAdd}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const body = await res.json();
        if (!res.ok) throw new Error(body.description || body.message || T.strings.error);
        atc.classList.add('is-added');
        atcLabel.textContent = 'Añadido';
        await refreshCart(true);
      } catch (err) {
        errEl.textContent = err.message || 'No se ha podido añadir el producto. Inténtalo de nuevo.';
        errEl.hidden = false;
      } finally {
        atc.classList.remove('is-loading');
        setTimeout(() => {
          atc.classList.remove('is-added');
          atcLabel.textContent = atc.disabled ? 'Agotado' : 'Añadir a la cesta';
        }, 1600);
      }
    });

    /* Gallery */
    const gallery = $('[data-gallery]', root);
    const stage = $('[data-gallery-stage]', root);
    const slides = $$('[data-gallery-slide]', root);
    const thumbs = $$('[data-gallery-thumb]', root);
    const dots = $$('.gallery__dot', root);
    const desktop = window.matchMedia('(min-width: 990px)');
    let current = 0;

    function setActive(i) {
      if (i === current || !slides[i]) return;
      slides.forEach((s) => s.classList.remove('is-prev'));
      slides[current].classList.add('is-prev');
      slides[current].classList.remove('is-active');
      slides[i].classList.add('is-active');
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      const prev = current;
      current = i;
      setTimeout(() => slides[prev] && slides[prev].classList.remove('is-prev'), 950);
      if (!desktop.matches) stage.scrollTo({ left: stage.clientWidth * i, behavior: motion ? 'smooth' : 'auto' });
    }
    function goToMedia(mediaId) {
      const idx = slides.findIndex((s) => String(s.dataset.mediaId) === String(mediaId));
      if (idx > -1) setActive(idx);
    }
    thumbs.forEach((t) => t.addEventListener('click', () => setActive(parseInt(t.dataset.galleryThumb, 10))));
    if (stage) {
      stage.addEventListener('scroll', () => {
        if (desktop.matches) return;
        const i = Math.round(stage.scrollLeft / stage.clientWidth);
        if (i !== current && slides[i]) {
          slides[current].classList.remove('is-active');
          slides[i].classList.add('is-active');
          dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
          current = i;
        }
      }, { passive: true });
      stage.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') setActive(Math.min(slides.length - 1, current + 1));
        if (e.key === 'ArrowLeft') setActive(Math.max(0, current - 1));
      });
    }

    /* Zoom */
    const dialog = $('[data-zoom-dialog]');
    if (dialog && typeof dialog.showModal === 'function') {
      const img = $('[data-zoom-img]', dialog);
      $$('[data-zoom]', root).forEach((btn) => btn.addEventListener('click', () => {
        const source = $('img', btn);
        img.src = btn.dataset.zoom;
        img.alt = source ? source.alt : '';
        dialog.showModal();
      }));
      $('[data-zoom-close]', dialog).addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => { if (e.target === dialog || e.target === img) dialog.close(); });
    }
    if (gallery && !slides.length) gallery.hidden = true;

    /* Size guide dialog */
    const guide = $('[data-size-guide-dialog]');
    if (guide && typeof guide.showModal === 'function') {
      $$('[data-size-guide-open]', root).forEach((btn) => btn.addEventListener('click', () => guide.showModal()));
      $('[data-size-guide-close]', guide).addEventListener('click', () => guide.close());
      guide.addEventListener('click', (e) => { if (e.target === guide) guide.close(); });
    }
  });

  /* ---------------------------------------------------------------------
     Hero slider with circular clip-path reveal from the arrow side
     --------------------------------------------------------------------- */
  $$('[data-hero]').forEach((hero) => {
    const slides = $$('[data-hero-slide]', hero);
    const dots = $$('[data-hero-dot]', hero);
    if (slides.length < 2) return;
    const delay = 7000;
    hero.style.setProperty('--hero-delay', `${delay}ms`);
    let i = 0;
    let timer;
    const go = (next, fromRight = true) => {
      next = (next + slides.length) % slides.length;
      if (next === i) return;
      slides.forEach((s) => s.classList.remove('is-prev'));
      const cur = slides[i];
      cur.classList.add('is-prev');
      cur.classList.remove('is-active');
      cur.setAttribute('aria-hidden', 'true');
      slides[next].style.setProperty('--cx', fromRight ? '92%' : '8%');
      slides[next].classList.add('is-active');
      slides[next].removeAttribute('aria-hidden');
      dots.forEach((d, k) => d.classList.toggle('is-active', k === next));
      setTimeout(() => cur.classList.remove('is-prev'), 1150);
      i = next;
    };
    const play = () => {
      clearInterval(timer);
      if (hero.dataset.autoplay === 'true' && motion) timer = setInterval(() => go(i + 1, true), delay);
    };
    $('[data-hero-next]', hero).addEventListener('click', () => { go(i + 1, true); play(); });
    $('[data-hero-prev]', hero).addEventListener('click', () => { go(i - 1, false); play(); });
    dots.forEach((d) => d.addEventListener('click', () => { const n = parseInt(d.dataset.heroDot, 10); go(n, n > i); play(); }));
    hero.addEventListener('mouseenter', () => { clearInterval(timer); hero.setAttribute('data-paused', ''); });
    hero.addEventListener('mouseleave', () => { hero.removeAttribute('data-paused'); play(); });
    hero.addEventListener('focusin', () => clearInterval(timer));
    let sx = null;
    hero.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      if (sx === null) return;
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 50) { go(dx < 0 ? i + 1 : i - 1, dx < 0); play(); }
      sx = null;
    });
    play();
  });

  /* ---------------------------------------------------------------------
     Showcase tabs (client-side filter with FLIP)
     --------------------------------------------------------------------- */
  $$('[data-showcase]').forEach((sc) => {
    const tabs = $('[data-tabs]', sc);
    if (!tabs) return;
    const pill = $('[data-tabs-pill]', tabs);
    const btns = $$('.tabs__btn', tabs);
    const cards = $$('[data-card]', sc);
    const placePill = (btn) => { pill.style.width = `${btn.offsetWidth}px`; pill.style.transform = `translateX(${btn.offsetLeft}px)`; };
    requestAnimationFrame(() => placePill($('.is-active', tabs)));
    window.addEventListener('resize', () => placePill($('.is-active', tabs)));
    btns.forEach((btn) => btn.addEventListener('click', () => {
      btns.forEach((b) => { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-selected', b === btn); });
      placePill(btn);
      const f = btn.dataset.filter;
      const first = new Map(cards.map((c) => [c, c.getBoundingClientRect()]));
      cards.forEach((c) => c.classList.toggle('is-filtered', f !== 'all' && c.dataset.gender !== f));
      if (!motion) return;
      cards.forEach((c) => {
        if (c.classList.contains('is-filtered')) return;
        const a = first.get(c);
        const b = c.getBoundingClientRect();
        if (!a.width) {
          c.animate([{ opacity: 0, transform: 'scale(.9)' }, { opacity: 1, transform: 'none' }], { duration: 500, easing: 'cubic-bezier(.2,.8,.2,1)' });
          return;
        }
        const dx = a.left - b.left;
        const dy = a.top - b.top;
        if (dx || dy) c.animate([{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'none' }], { duration: 650, easing: 'cubic-bezier(.7,0,.2,1)' });
      });
    }));
  });

  /* ---------------------------------------------------------------------
     Order tracking: order number + email, or tracking number
     --------------------------------------------------------------------- */
  $$('[data-track]').forEach((card) => {
    const tabs = $$('[data-track-tab]', card);
    const panels = $$('[data-track-panel]', card);
    const pill = $('[data-tabs-pill]', card);
    const placePill = (btn) => {
      if (!pill || !btn) return;
      pill.style.width = `${btn.offsetWidth}px`;
      pill.style.transform = `translateX(${btn.offsetLeft}px)`;
    };
    const select = (name, focus) => {
      tabs.forEach((t) => {
        const on = t.dataset.trackTab === name;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on);
        if (on) placePill(t);
      });
      panels.forEach((p) => {
        p.hidden = p.dataset.trackPanel !== name;
        if (!p.hidden && focus) $('input', p).focus();
      });
    };
    tabs.forEach((t) => t.addEventListener('click', () => select(t.dataset.trackTab, true)));
    requestAnimationFrame(() => placePill($('.is-active', card)));
    window.addEventListener('resize', () => placePill($('.is-active', card)));
    // Deep link: /pages/track-your-order#tracking-number opens the second tab
    if (window.location.hash === '#tracking-number') select('number', false);

    const showError = (form, msg) => {
      const err = $('[data-track-error]', form);
      err.textContent = msg;
      err.hidden = !msg;
    };
    panels.forEach((form) => {
      form.addEventListener('submit', (e) => {
        const inputs = $$('input', form);
        inputs.forEach((i) => { i.value = i.value.trim(); });
        if (form.dataset.trackPanel === 'order') {
          const order = $('[name="order"]', form);
          const email = $('[name="email"]', form);
          if (!order.value) { e.preventDefault(); showError(form, 'Introduce el número de pedido.'); order.focus(); return; }
          if (!email.validity.valid || !email.value) { e.preventDefault(); showError(form, 'Introduce el correo electrónico con el que hiciste el pedido.'); email.focus(); return; }
        } else {
          const num = $('[name="nums"]', form);
          num.value = num.value.replace(/\s+/g, '').toUpperCase();
          if (num.value.length < 6) { e.preventDefault(); showError(form, 'Introduce un número de seguimiento válido.'); num.focus(); return; }
        }
        showError(form, '');
      });
      const correosBtn = $('[data-track-correos]', form);
      if (correosBtn) correosBtn.addEventListener('click', () => {
        const num = $('[name="nums"]', form);
        const value = num.value.replace(/\s+/g, '').toUpperCase();
        if (value.length < 6) { showError(form, 'Introduce un número de seguimiento válido.'); num.focus(); return; }
        showError(form, '');
        window.open(`${form.dataset.correos}?tracking-number=${encodeURIComponent(value)}`, '_blank', 'noopener');
      });
    });
  });

  /* ---------------------------------------------------------------------
     Collection: sort + size filter submit on change
     --------------------------------------------------------------------- */
  $$('[data-sort-select]').forEach((s) => s.addEventListener('change', () => s.form.submit()));
  $$('[data-filter-input]').forEach((i) => i.addEventListener('change', () => i.form.submit()));

  /* ---------------------------------------------------------------------
     Cookie preferences: reopen Shopify's consent banner from the footer
     --------------------------------------------------------------------- */
  $$('[data-cookie-prefs]').forEach((btn) => btn.addEventListener('click', () => {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    } else {
      window.location.href = `${T.routes.root}pages/cookie-policy`;
    }
  }));

  /* ---------------------------------------------------------------------
     FAQ: only one open at a time, smooth height
     --------------------------------------------------------------------- */
  $$('[data-faq]').forEach((faq) => {
    const items = $$('details', faq);
    items.forEach((d) => d.addEventListener('toggle', () => {
      if (d.open) items.forEach((o) => { if (o !== d) o.open = false; });
    }));
  });

  /* ---------------------------------------------------------------------
     Motion layer
     --------------------------------------------------------------------- */
  // Split headings into masked lines (keeps <br> line breaks the author set)
  $$('[data-split-lines]').forEach((el) => {
    if (!motion) return;
    const parts = el.innerHTML.split(/<br\s*\/?>/i).map((s) => s.trim()).filter(Boolean);
    el.innerHTML = parts.map((p, k) => `<span class="line-mask" style="--l:${k}"><span>${p}</span></span>`).join('');
  });

  if (motion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    $$('[data-reveal], [data-split-lines], .grid--products .card, .page__hero, .collection__hero').forEach((el) => io.observe(el));
  } else {
    $$('[data-reveal], .card, [data-split-lines]').forEach((el) => el.classList.add('is-in'));
  }

  // Cursor-origin reveal for second images
  if (finePointer) {
    $$('[data-reveal-cursor]').forEach((el) => {
      el.addEventListener('pointerenter', (e) => {
        const r = el.getBoundingClientRect();
        el.style.setProperty('--x', `${((e.clientX - r.left) / r.width) * 100}%`);
        el.style.setProperty('--y', `${((e.clientY - r.top) / r.height) * 100}%`);
      });
    });
  }

  // Button fill follows the pointer; magnetic pull on desktop
  $$('.btn').forEach((btn) => {
    btn.addEventListener('pointerenter', (e) => {
      const r = btn.getBoundingClientRect();
      btn.style.setProperty('--bx', `${e.clientX - r.left}px`);
      btn.style.setProperty('--by', `${e.clientY - r.top}px`);
    });
    btn.addEventListener('pointerleave', (e) => {
      const r = btn.getBoundingClientRect();
      btn.style.setProperty('--bx', `${e.clientX - r.left}px`);
      btn.style.setProperty('--by', `${e.clientY - r.top}px`);
    });
  });
  if (motion && finePointer) {
    $$('[data-magnetic]').forEach((el) => {
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const dx = (e.clientX - (r.left + r.width / 2)) * 0.18;
        const dy = (e.clientY - (r.top + r.height / 2)) * 0.28;
        el.style.transform = `translate(${dx}px, ${dy}px)`;
      });
      el.addEventListener('pointerleave', () => { el.style.transform = ''; });
    });
  }

  // Parallax + marquee driven by one rAF loop
  const parallaxEls = motion ? $$('[data-parallax]') : [];
  const marquees = motion ? $$('[data-marquee]').map((m) => ({ el: m, track: $('[data-marquee-track]', m), x: 0 })) : [];
  if (parallaxEls.length || marquees.length) {
    let prevY = window.scrollY;
    let velocity = 0;
    let direction = 1;
    const loop = () => {
      const y = window.scrollY;
      const delta = y - prevY;
      prevY = y;
      if (delta !== 0) direction = delta > 0 ? 1 : -1;
      velocity += (Math.min(Math.abs(delta), 60) - velocity) * 0.08;
      const vh = window.innerHeight;
      parallaxEls.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        const centre = r.top + r.height / 2 - vh / 2;
        el.style.translate = `0 ${(-centre * parseFloat(el.dataset.parallax)).toFixed(1)}px`;
      });
      marquees.forEach((m) => {
        const half = m.track.scrollWidth / 2;
        if (!half) return;
        m.x -= (0.6 + velocity * 0.35) * direction;
        if (m.x <= -half) m.x += half;
        if (m.x > 0) m.x -= half;
        m.track.style.transform = `translate3d(${m.x.toFixed(2)}px,0,0)`;
      });
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }
})();
